module.exports = __webpack_public_path__ + "images/application/i-navigation-5957c4fb.svg";